import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {Observable} from 'rxjs/Observable';
import index from '@angular/cli/lib/cli';

@Injectable()
export class VnaServicesService {

    constructor(private api: ApiService) { }

    getVnaServices(): Observable<any>{
        return this.api.get('vna/service');
    }

    getVnaService(pk: number): Observable<any> {
        return this.api.get('vna/service/' + pk);
    }

    putVnaService(pk, data: Object): Observable<any> {
        return this.api.put('vna/service', pk, data);
    }

    postVnaService(data: Object): Observable<any> {
        return this.api.post('vna/service', data);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/service/vna-services.service.ts